import { render, staticRenderFns } from "./aRoomFeeCallable.vue?vue&type=template&id=05a7bf5c&scoped=true"
import script from "./aRoomFeeCallable.vue?vue&type=script&lang=js"
export * from "./aRoomFeeCallable.vue?vue&type=script&lang=js"
import style0 from "./aRoomFeeCallable.vue?vue&type=style&index=0&id=05a7bf5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a7bf5c",
  null
  
)

export default component.exports